import React from "react"
import { Table, Column, PageBar } from "@tencent/spaui"
import { PARTICIPATION_STATUS } from "@/constants/Constants"

class ActivityList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageIndex: 0,
      pageSize: 20,
    }
    this.props.getActivityListThis && this.props.getActivityListThis(this)
  }

  getData = (pageSize, pageIndex) => {
    this.props.getData && this.props.getData({ pageSize, pageIndex })
  }

  initPage = () => {
    this.setState({
      pageIndex: 0,
      pageSize: 20,
    })
  }

  handleChangePageIndex = (event, value, pageSize) => {
    this.setState(
      {
        pageIndex: value - 1,
        pageSize,
      },
      () => {
        this.getData(pageSize, value - 1)
      }
    )
  }

  handleChangePageSize = (value, pageSize) => {
    this.setState(
      {
        pageIndex: value - 1,
        pageSize,
      },
      () => {
        this.getData(pageSize, value - 1)
      }
    )
  }

  renderName = (type, name, value, data) => {
    if (type === "head") {
      return value
    }
    const { activityName, activityId } = data
    return <div>{`${activityName}(${activityId})`}</div>
  }

  renderAttendStatus = (type, name, value, data) => {
    if (type === "head") {
      return value
    }
    return <div>{PARTICIPATION_STATUS[value] || "-"}</div>
  }

  renderList = () => {
    const { pageIndex, pageSize } = this.state
    const { loading, data = {} } = this.props
    const { conf = {}, items = [] } = data
    return (
      <React.Fragment>
        <Table cssFixedTheadAble scrollTarget="body" setCssFixedTheadSpace={() => 40} data={items} loading={loading}>
          <Column name="activityName" render={this.renderName}>
            活动名称(ID)
          </Column>
          <Column name="activityType">活动类型</Column>
          <Column name="activityUrl">活动URL</Column>
          <Column name="activityLabel">活动标签</Column>
          <Column name="attendStatus" render={this.renderAttendStatus}>
            参与状态
          </Column>
        </Table>
        <PageBar value={pageIndex + 1} pageSize={pageSize} totalSize={conf?.totalCount || 0} pageSizeList={[10, 20, 50, 100, 200]} onChange={this.handleChangePageIndex} onPageSizeChange={this.handleChangePageSize} />
      </React.Fragment>
    )
  }

  render() {
    return this.renderList()
  }
}

export default ActivityList
